import { AxiosError } from 'axios';

import { setMaintenanceActive } from '@/contexts/maintenance/Maintenance.context.ts';

import { HTTP_STATUS } from './ErrorCode.model';
import { HTTP_HEADER } from './httpHeaders.model';

type MaintenanceResponseBody = {
  maintenanceEnd?: string;
  maintenanceEndDate?: string;
  maintenanceMessage?: string | null;
  maintenanceMode?: boolean;
  messageEn?: string;
  messagePl?: string;
};

const isMaintenanceResponse = (error: AxiosError<MaintenanceResponseBody>): boolean => {
  const response = error.response;
  if (!response || response.status !== HTTP_STATUS.SERVICE_UNAVAILABLE) {
    return false;
  }
  const headerValue = response.headers?.[HTTP_HEADER['X-Maintenance-Mode'].toLowerCase()];
  return headerValue === 'true' || response.data?.maintenanceMode === true;
};

export const maintenanceErrorInterceptor = (error: unknown): Promise<never> => {
  const axiosError = error as AxiosError<MaintenanceResponseBody>;
  if (isMaintenanceResponse(axiosError)) {
    const data = axiosError.response?.data;
    setMaintenanceActive({
      maintenanceEnd: data?.maintenanceEnd,
      maintenanceEndDate: data?.maintenanceEndDate,
      maintenanceMessage: data?.maintenanceMessage ?? undefined,
      messageEn: data?.messageEn,
      messagePl: data?.messagePl,
    });
    return new Promise<never>(() => {});
  }
  return Promise.reject(error);
};
